import React from "react";
import styles from "./styles.module.scss";

/**
 * Three checkbox styles
 * - 'gray', 'black', 'mint'
 */
const CheckBox = ({
    name,
    selected,
    onChange,
    dataTestId,
    children,
    disabled,
    small,
    styleName,
    ariaLabel,
}) => {
    let containerStyles = [styles.checkbox];
    small && containerStyles.push(styles.small);

    let labelStyles = [styles.box];
    disabled && labelStyles.push(styles.disabled);

    let iconStyles = [styles.mark, styles[styleName]];
    small && iconStyles.push(styles.smallIcon);

    return (
        <span className={containerStyles.join(" ")}>
            <label className={labelStyles.join(" ")} aria-label={ariaLabel}>
                <input
                    checked={selected}
                    name={name}
                    onChange={onChange}
                    type="checkbox"
                    disabled={disabled}
                    aria-label={ariaLabel}
                />
                <span
                    className={iconStyles.join(" ")}
                    data-testid={dataTestId}
                />
                {children}
            </label>
        </span>
    );
};

export default CheckBox;
export const CheckBoxes = ({
    options,
    displayNames,
    selected,
    setter,
    disabled,
    dataTestId,
    ariaLabel,
}) => {
    const handleChange = (e, checked) => {
        const next = selected.filter((opt) => opt !== e.target.name);
        if (checked) {
            setter(next);
        } else {
            setter([e.target.name, ...next]);
        }
    };

    const boxes = options.map((opt, idx) => {
        const checked = selected ? selected.includes(opt) : false;
        return (
            <CheckBox
                key={idx}
                name={opt}
                selected={checked}
                onChange={(e) => handleChange(e, checked)}
                disabled={disabled}
                small
                dataTestId={`${dataTestId}-select-${opt}`}
                styleName="black"
                ariaLabel={`${ariaLabel}-${opt}`}
            >
                {displayNames[idx]}
            </CheckBox>
        );
    });

    return <div className={styles.checkboxes}>{boxes}</div>;
};
